const isBrowser = typeof window !== 'undefined'

type UseScreenSizeProps = {
  width: number
  height: number
}

const useScreenSize = (skip = false): UseScreenSizeProps => {
  if (!skip && isBrowser) {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  }

  return { width: 0, height: 0 }
}

export default useScreenSize
